/**
 * KAN-688: photo of a manual message - accepted types and client-side checks.
 * The backend checks the same limits again by the file signature.
 */

/** Photo types accepted by the backend. */
export const PHOTO_ACCEPT = 'image/jpeg,image/png,image/webp'
export const PHOTO_MAX_BYTES = 10 * 1024 * 1024

const PHOTO_TYPES = PHOTO_ACCEPT.split(',')

/** Error text for a picked file, or null when it can be sent. */
export function photoError(file: File): string | null {
  if (!PHOTO_TYPES.includes(file.type)) {
    return 'Можно прикрепить только фото JPEG, PNG или WEBP'
  }
  if (file.size > PHOTO_MAX_BYTES) return 'Фото больше 10 МБ'
  if (file.size === 0) return 'Пустой файл фото'
  return null
}
